import { selectCurrentUser } from 'features/auth/slice';
import { useSelector } from 'react-redux';

import { useModal } from '@frontendmentorio/design-system-v2';

import AuthButton from 'features/shared/AuthButton';
import Modal from './Modal';
import NoCreditsLockMessage from 'features/shared/NoCreditsLockMessage';
import ProLockMessage from 'features/shared/ProLockMessage';

export default function CTA({
  challenge,
  onStart: handleStart,
  proLockMessage,
}) {
  const currentUser = useSelector(selectCurrentUser);
  const modal = useModal();

  const hasCredits = currentUser?.credits.premium > 0;
  const infiniteCredits = !isFinite(+currentUser?.credits.premium);
  const isPurchased = currentUser?.purchases.includes(challenge.id);
  const isPremium = challenge?.type === 'premium';
  const isUnlocked = !isPremium || infiniteCredits || isPurchased;

  const handleClick = () => {
    if (isUnlocked) return handleStart();

    modal.open();
  };

  if (!isUnlocked && !hasCredits) {
    if (currentUser?.hasActiveSubscription) {
      return <NoCreditsLockMessage currentUser={currentUser} />;
    }

    return <ProLockMessage withCTA>{proLockMessage}</ProLockMessage>;
  }

  return (
    <>
      <AuthButton isWide onClick={handleClick}>
        Start challenge
      </AuthButton>

      {currentUser && <Modal modal={modal} startChallenge={handleStart} />}
    </>
  );
}
